module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_troms_og_finnmark_pos.e6141f92.svg";